// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import FastForwardOutlinedSvg from "@ant-design/icons-svg/es/asn/FastForwardOutlined";
import AntdIcon from '../components/AntdIcon';

var FastForwardOutlined = function FastForwardOutlined(props, ref) {
  return /*#__PURE__*/React.createElement(AntdIcon, Object.assign({}, props, {
    ref: ref,
    icon: FastForwardOutlinedSvg
  }));
};

FastForwardOutlined.displayName = 'FastForwardOutlined';
export default /*#__PURE__*/React.forwardRef(FastForwardOutlined);